import { render, staticRenderFns } from "./link-form-grid.vue?vue&type=template&id=21549a43&"
import script from "./link-form-grid.vue?vue&type=script&lang=js&"
export * from "./link-form-grid.vue?vue&type=script&lang=js&"
import style0 from "./link-form-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports